import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const NoteFromBuyerCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Order note", cell: (row) => row.noteFromBuyer || "" };
